module.exports = __webpack_public_path__ + "fonts/opensans-bold.a448784c.woff2";